import { render, staticRenderFns } from "./VisualizarCancelamento.vue?vue&type=template&id=10ea7a48"
import script from "./VisualizarCancelamento.vue?vue&type=script&lang=js"
export * from "./VisualizarCancelamento.vue?vue&type=script&lang=js"
import style0 from "./VisualizarCancelamento.vue?vue&type=style&index=0&id=10ea7a48&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports